'use strict';

import $ from 'jquery';
import slick from 'slick-carousel';
import gallery from 'lightgallery';


export default function() {

    $('.gallery').each(function () {

        $('.gallery__content', this).slick({
            infinite: true,
            arrows: true,
            slide: '.gallery__item',
            prevArrow: $('.gallery__prev', this),
            nextArrow: $('.gallery__next', this),
            speed: 500,
            dots: false,
            slidesToShow: 1
        });
    });

    $(".gallery__content").lightGallery({
        selector: '.gallery__item'
    });



}
